import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FlaskConical,
  Package,
  ArrowRight,
  Pill,
  Activity,
} from "lucide-react";

export default function ViewAllCategories() {
  const navigate = useNavigate();
  const location = useLocation();

  // 🔥 same items (reuse)
  const items = [
    {
      name: "Lab Tests",
      icon: <FlaskConical size={30} />,
      route: "/all-tests",
      from: "labtests",
    },
    {
      name: "Packages",
      icon: <Package size={30} />,
      route: "/lab",
      from: "packages",
    },
    {
      name: "Medicines",
      icon: <Pill size={30} />,
      route: "/medicines",
      from: "medicines",
    },
    {
      name: "Lab",
      icon: <Activity size={30} />,
      route: "/lab",
      from: "lab",
    },
  ];

  const handleClick = (item) => {
    navigate(item.route, {
      state: {
        from: item.from,
        name: item.name,
      },
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 p-5">

      <h2 className="text-3xl font-bold text-center text-red-600 mb-6">
        All Services
      </h2>

      {/* 🔥 GRID FULL VIEW */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {items.map((item, i) => (
          <div
            key={i}
            onClick={() => handleClick(item)}
            className="cursor-pointer flex flex-col items-center p-6 bg-white rounded-xl shadow-md border hover:shadow-xl transition"
          >
            <div className="w-14 h-14 flex items-center justify-center bg-red-100 text-red-600 rounded-xl">
              {item.icon}
            </div>

            <span className="mt-3 font-semibold text-gray-700">
              {item.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}